<ppl-dialog
  [title]="title"
  [width]="width"
  [actionLabel]="actionLabel"
  [actionDisabled]="actionDisabled"
  [actionButtonType]="actionButtonType"
  [loading]="loading || (init$ | async) || (verifying$ | async)"
  (action)="onAction()"
  (cancel)="onCancel()"
  [formGroupNoPadding]="true"
  [formGroup]="form">
  @if (error$ | async; as error) {
    <div class="error-container">
      <ppl-error-box>
        @switch (error.error) {
          @case (TwoFactorError.TOO_MANY_REQUESTS) {
            {{ getRetryAfterMessage(error) }}
          }
          @case (TwoFactorError.INVALID_OR_EXPIRED_TOKEN) {
            <ng-container i18n="@@Invalid_or_expired_token.">Invalid or expired token.</ng-container>
          }
          @default {
            <ng-container i18n="@@Unknown_error.">Unknown error.</ng-container>
          }
        }
      </ppl-error-box>
    </div>
  }
  @switch (step) {
    @case (TwoFactorMethodSetupCommonStep.VERIFY) {
      <ppl-two-factor-method-setup-verify
        formControlName="code"
        [showResendCode]="showResendCode"
        [sentTo]="initData.setupData.value"
        (resendCode)="onResendCode()">
        <div
          class="verify-status-container"
          ngProjectAs="extra-input-content">
          @if (codeFormControl.invalid && (codeFormControl.dirty || codeFormControl.touched)) {
            <ppl-form-control-errors [errors]="codeFormControl.errors"></ppl-form-control-errors>
          }
          @if (resendSetupToggleSentMessage$ | async) {
            <div
              class="code-sent-message"
              i18n="@@New_code_was_sent">
              New code was sent
            </div>
          }
        </div>
      </ppl-two-factor-method-setup-verify>
    }
    @default {
      <ng-content></ng-content>
    }
  }
</ppl-dialog>
